import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAircallRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#00B388",
		fillRule: "evenodd",
		d: "M22.6 3.6Q20.2 3 16 3t-6.6.6c-3 .6-5.2 2.9-5.8 5.8Q3 11.8 3 16t.6 6.6c.6 3 2.9 5.2 5.8 5.8q2.4.6 6.6.6t6.6-.6c3-.6 5.2-2.9 5.8-5.8q.6-2.4.6-6.6t-.6-6.6c-.6-3-2.9-5.2-5.8-5.8",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M19.1 23a2 2 0 0 0-1.4-1.2l-1.7-.1-1.7.1a2 2 0 0 0-1.4 1.2q-.2.3-.5.3h-.2l-2.3-.5-.5-.7V22c0-1.1.7-3.6 1.7-6.4 1.1-3.3 2.2-5.9 2.8-6.4l.3-.2h.1l1.7-.3 1.7.2h.1l.3.3c.6.5 1.7 3.1 2.8 6.4 1 2.8 1.6 5.3 1.7 6.4q0 .6-.5.8-.8.3-2.3.4h-.2z"
	})]
});
export default SvgAircallRegularIcon;
